import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '.';
import { environment } from '../../environments/environment';

@Injectable()
export class SignalRService {

    hubConnection: HubConnection;
    

    constructor(private authService: AuthService) {
    }

    connectionId: string;

    private notificationMessage = new BehaviorSubject(null);
    private location = new BehaviorSubject(null);
    private sendQrCode = new BehaviorSubject(null);
    private inputWarehouse = new BehaviorSubject(null);
    private outputWarehouse = new BehaviorSubject(null);
    private scaleChange = new BehaviorSubject(null);
    private logout = new BehaviorSubject(null);

    checkNotification = this.notificationMessage.asObservable();
    checkLocation = this.location.asObservable();
    checkRequestInputWarehouse = this.inputWarehouse.asObservable();
    checkSendQrCode = this.sendQrCode.asObservable();
    checkRequestOutputWarehouse = this.outputWarehouse.asObservable();
    checkWeighingScaleChange = this.scaleChange.asObservable()
    checkLogout = this.logout.asObservable()

    GetConnection() {
        return this.hubConnection;
    }

    async Connect() {
        this.hubConnection = await new HubConnectionBuilder().withUrl(environment.apiPostUrl + "/SignalR").build();
        await this.hubConnection.start();
        return this.hubConnection;
    }

    async Disconnect() {
        if (this.hubConnection)
            await this.hubConnection.stop();
    }

    async registerUserToHub() {
        this.hubConnection.invoke("RegisterUserToHub", this.authService.getUserId());
      }
    
    async awaitReceiverNotification() {
      // Backend gửi 2 tham số riêng qua SendAsync("AwaitReceiverNotification", notificationName, obj) -
      // gộp lại thành 1 object {notificationName, data} vì các chỗ dùng (header, create-shipment) đều đọc theo shape này.
      this.hubConnection.on("AwaitReceiverNotification", (notificationName, data) => {
        if (notificationName) {
          this.notificationMessage.next({ notificationName, data });
        }
      });
    }

    async awaitSendQrCode() {
      this.hubConnection.on("AwaitSendQrCode", (res) => {
        if (res) {
          this.sendQrCode.next(res);
        }
      });
    }

    async awaitLogout() {
      this.hubConnection.on("LogOut", (res) => {
        if (res) {
          this.logout.next(res);
        }
      });
    }


    async updatePosition() {
      this.hubConnection.on("UpdatePosition", (res) => {
        if (res) {
          this.location.next(res);
        }
      });
    }

    async requestInputWarehouse() {
      this.hubConnection.on("RequestInputWarehouse", (res) => {
        if (res) {
          this.inputWarehouse.next(res);
        }
      });
    }

    async requestOutputWarehouse() {
      this.hubConnection.on("RequestOutputWarehouse", (res) => {
        if (res) {
          this.outputWarehouse.next(res);
        }
      });
    }

    async weighingScaleChange() {
      this.hubConnection.on("WeighingScaleChange", (res) => {
        if (res) {
          this.scaleChange.next(res);
        }
      });
    }
}